/**
 * Plain-text projection of the open document, computed once per doc change
 * (#250). Entity peek, Harper and their overlap check all read it from
 * here instead of re-projecting.
 */

import { Plugin, PluginKey, type EditorState } from "prosemirror-state";
import {
  projectPlainText,
  type PlainTextProjection,
} from "../../lib/zwdoc/plainText";

const projectionKey = new PluginKey<PlainTextProjection>("zwProjection");

export function projectionPlugin(): Plugin<PlainTextProjection> {
  return new Plugin<PlainTextProjection>({
    key: projectionKey,
    state: {
      init: (_config, state) => projectPlainText(state.doc),
      apply: (tr, value) => (tr.docChanged ? projectPlainText(tr.doc) : value),
    },
  });
}

/** The projection for `state` (computed on the fly without the plugin). */
export function projectionOf(state: EditorState): PlainTextProjection {
  return projectionKey.getState(state) ?? projectPlainText(state.doc);
}
